import type { VoidFunctionComponent } from 'react';

import { icons, NavigationButton } from '../../../generic';

import styles from './AddProjectsCTA.module.less';

const AddProjectsCTA: VoidFunctionComponent = () => {
  return (
    <div className={styles.addProjectsCTA}>
      <div className={styles.message}>
        There aren&apos;t any projects here! Get started by importing some with the button below:
      </div>
      <NavigationButton to="/projects/import" size="medium" icon={icons.plus}>
        Add Projects
      </NavigationButton>
    </div>
  );
};

export default AddProjectsCTA;
